<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <Row class="loading" :style="loading==true ? '' : 'display:none'">
      <Col class="demo-spin-col" span="8">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中</div>
        </Spin>
      </Col>
    </Row>

    <div style="margin-bottom: 10px;">
      <el-select size="mini" v-model="status" filterable placeholder="审核" class="kuan" v-if="ERP.isPermission(3001001001)">
        <el-option
          key=""
          label="全部状态"
          value="">
        </el-option>
        <el-option
          v-for="item in [{id:1,name:'待审核'},{id:2,name:'已审核'},{id:3,name:'已拒绝'}]"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select size="mini" v-model="pid" filterable placeholder="请选择组织" class="kuan" v-if="ERP.isPermission(3001001001)">
        <el-option
          key=""
          label="全部"
          value="">
        </el-option>
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    </div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">提交人</th>
          <th class="text-left">房产</th>
          <th class="text-left">日结日期</th>
          <th class="text-left">状态</th>
          <th class="text-left">提交时间</th>
          <th class="text-left">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr class="text1" v-for="item in data" :key="item.id">
          <td >{{item.id}}</td>
          <td >{{item.name}}</td>
          <td >{{item.house}}</td>
          <td >{{item.rijie_date}}</td>
          <td >{{item.status}}</td>
          <td >{{item.date}}</td>
          <td class="cdj_td">
            <div style="color: #1867c0;cursor: pointer;" @click="xiugai(item)" v-if="ERP.isPermission(3001001003)">查看</div>
            <div style="color: red;margin-left: 5px;cursor: pointer;" @click="shenhe( item.id )" v-if="ERP.isPermission(3001001004) && item.status == '待审核'">审核</div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="data">
      <Page :total="count" :page-size="pageSize" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>

    <!-- 审核 -->
    <Modal
      v-model="modal2"
      ok-text="审核"
      width="815"
      title="审核"
      :loading="loadingModal"
      @on-ok="oks">
      <div>
        <el-form style="height: 600px;overflow: auto;">
          <div class="cdj_margin_span">
            <span>审核</span>
            <div style="margin-top: 5px;">
              <el-radio v-model="radio" label="2">通过</el-radio>
              <el-radio v-model="radio" label="3">拒绝</el-radio>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>备注</span>
            <el-input class="cdj_input" type="textarea" v-model="remarks" :rows="3" placeholder="备注"></el-input>
          </div>
        </el-form>
      </div>
    </Modal>
    <!-- 查看 -->
    <Modal
      v-model="modal1"
      ok-text="关闭"
      width="815"
      title="查看"
      :loading="loadingModal"
      @on-ok="ok">
      <div>
        <el-form style="height: 600px;overflow: auto;">
          <div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>提交人</span>
                <el-input class="cdj_input" v-model="dataform.name" placeholder="提交人" :disabled="true"></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>提交人部门</span>
                <el-input class="cdj_input"  v-model="dataform.department" placeholder="提交人部门" :disabled="true"></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>提交人职位</span>
                <el-input class="cdj_input" v-model="dataform.position" placeholder="提交人职位" :disabled="true"></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>房产</span>
                <el-input class="cdj_input" v-model="homeName" placeholder="点击左边树选择房产" :disabled="true"></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>日结日期</span>
                <div><el-date-picker class="cdj_input" style="width:100%" v-model="date" type="date" placeholder="选择日期" :disabled="true"></el-date-picker></div>
                <div style="margin-top:5px;"><el-button  @click="list" size="mini">统计收银日报表</el-button></div>
              </div>
              <div class="cdj_margin_span">
                <span>本日收入货币形态</span>
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="pay_margin">
                    <div>财到家</div>
                    <div><el-input class="cdj_input" v-model="dataform.caidaojia_money" placeholder="财到家" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>刷卡</div>
                    <div><el-input class="cdj_input" v-model="dataform.swipe_money" placeholder="刷卡" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>转账</div>
                    <div><el-input class="cdj_input" v-model="dataform.transfer_money" placeholder="转账" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>银联代扣</div>
                    <div><el-input class="cdj_input" v-model="dataform.union_pay_money" placeholder="银联代扣" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>银联商务</div>
                    <div><el-input class="cdj_input" v-model="dataform.union_pay_business_money" placeholder="银联商务" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>现金</div>
                    <div><el-input class="cdj_input" v-model="dataform.cash_money" placeholder="现金" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>码上付</div>
                    <div><el-input class="cdj_input" v-model="dataform.code_money" placeholder="码上付" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>其它</div>
                    <div><el-input class="cdj_input" v-model="dataform.other_money" placeholder="其它" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin" style="margin-top: 5px;">
                    <div>合计金额</div>
                    <div><el-input class="cdj_input" v-model="dataform.sum_money" placeholder="合计金额" :disabled="true"></el-input></div>
                  </div>
                </div>
              </div>
              <div class="cdj_margin_span">
                <span>库存现金</span>
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="pay_margin">
                    <div>上日结存</div>
                    <div><el-input class="cdj_input" v-model="dataform.yesterday" placeholder="上日结存" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>本日增加</div>
                    <div><el-input class="cdj_input" v-model="dataform.today_increase" placeholder="本日增加" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>本日转存</div>
                    <div><el-input class="cdj_input" v-model="dataform.today_transfer" placeholder="本日转存" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>本日结存</div>
                    <div><el-input class="cdj_input" v-model="dataform.today_knot" placeholder="本日结存" :disabled="true"></el-input></div>
                  </div>
                </div>
              </div>
              <div class="cdj_margin_span">
                <span>本日收入银行实存费</span>
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="pay_margin">
                    <div>一般户</div>
                    <div><el-input class="cdj_input" v-model="dataform.general_household" placeholder="一般户" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>手续费</div>
                    <div><el-input class="cdj_input" v-model="dataform.service_charge" placeholder="手续费" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>合计金额</div>
                    <div><el-input class="cdj_input" v-model="dataform.sum_bank" placeholder="合计金额" :disabled="true"></el-input></div>
                  </div>
                </div>
              </div>
              <div class="cdj_margin_span">
                <span>本日已开票款项</span>
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="pay_margin">
                    <div>实际开票金额</div>
                    <div><el-input class="cdj_input" v-model="dataform.bill_money" placeholder="开票金额" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>实际录入金额</div>
                    <div><el-input class="cdj_input" v-model="dataform.bill_input" placeholder="录入金额" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>差异</div>
                    <div><el-input class="cdj_input" v-model="dataform.bill_discrepancy" placeholder="差异" :disabled="true"></el-input></div>
                  </div>
                  <div class="pay_margin">
                    <div>原因</div>
                    <div><el-input class="cdj_input" v-model="dataform.bill_cause" style="width:478px;" placeholder="原因"></el-input></div>
                  </div>
                </div>

              </div>
              <div class="cdj_margin_span">
                <span>备注</span>
                <el-input class="cdj_input" type="textarea" v-model="dataform.remarks" :rows="3" placeholder="备注"></el-input>
              </div>
          </div>
        </el-form>
      </div>
    </Modal>
  </div>
</div>

</template>

<script>
import ErpTree from "../Common/erp-tree";
export default {
  name: 'OrderDailyCheck',
  components: {ErpTree},
  data () {
    return {
      modal1: false,
      modal2: false,
      loading:false,
      loadingModal:true,
      optionsHouse:[],
      dataform:{
        id:'',
        pindex_id:'',
        name:'',
        department:'',
        position:'',
        house:'',
        rijie_date:'',
        caidaojia_money:'',
        swipe_money:'',
        transfer_money:'',
        union_pay_money:'',
        union_pay_business_money:'',
        cash_money:'',
        code_money:'',
        other_money:'',
        sum_money:'',
        yesterday:'',
        today_increase:'',
        today_transfer:'',
        today_knot:'',
        general_household:'',
        service_charge:'',
        sum_bank:'',
        bill_money:'',
        bill_input:'',
        bill_discrepancy:'',
        bill_cause:'',
        remarks:''
      },
      options: [],
      pid: '',
      data: '',
      count:0,
      pageSize:12,
      text:'',
      anxiu:'关闭',
      homeName:'',
      date:'',
      pid:'',
      homeName:'',
      radio:'',
      remarks:'',
      id:'',
      status:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.options = backdata.data.data;
    });
  },
  //事件
  methods: {
    //查看关闭
    ok(){
      this.modal1 = false;
      this.loading = false;
    },
    //获得当前多少页,分页
    change(page){
      this.loading = true;
      this.$myhttp.get('admin/OrderDailyList/getCheck?page='+ page + '&pid='+ this.pid +'&text='+this.text+"&homeName="+this.homeName+"&status="+this.status,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            let data = backdata.data.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
          this.loading = false;
      });
    },
    list(){
      if(this.pid == "" || this.pid == null){
        this.$Message.error('点击左边树选择房产');
        return false;
      }
      if(this.date == '' || this.date ==null){
        this.$Message.error('选择日结日期');
        return false;
      }
      let d = this.date;//开始时间
      let date = new Date(d).getTime()/1000;
      let da = this.dades(date);
      let urls = "/#/OrderDaily/list?pid="+this.pid+'&homeName='+this.homeName+'&date='+da;
      window.open(urls, '_blank');
    },
    //时间戳转日期
    dades(value){
      let date = new Date(parseInt(value) * 1000);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let minute = date.getMinutes();
      let second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + '-' + m + '-' + d;
    },
    //搜索
    searchs(){
      this.change(1);
    },
    //修改
    xiugai(item){
      this.dataform={
        id:item.id,
        pindex_id:item.pindex_id,
        name:item.name,
        department:item.department,
        position:item.position,
        house:item.house,
        rijie_date:item.rijie_date,
        caidaojia_money:item.caidaojia_money,
        swipe_money:item.swipe_money,
        transfer_money:item.transfer_money,
        union_pay_money:item.union_pay_money,
        union_pay_business_money:item.union_pay_business_money,
        cash_money:item.cash_money,
        code_money:item.code_money,
        other_money:item.other_money,
        sum_money:item.sum_money,
        yesterday:item.yesterday,
        today_increase:item.today_increase,
        today_transfer:item.today_transfer,
        today_knot:item.today_knot,
        general_household:item.general_household,
        service_charge:item.service_charge,
        sum_bank:item.sum_bank,
        bill_money:item.bill_money,
        bill_input:item.bill_input,
        bill_discrepancy:item.bill_discrepancy,
        bill_cause:item.bill_cause,
        remarks:item.remarks
      }
      this.date=item.rijie_date;
      this.pid=item.pindex_id;
      this.homeName=item.house;
      this.modal1 = true;
    },
    //审核
    shenhe(e){
      this.id = e;
      this.modal2 = true;
    },
    oks(){
      if(this.radio == ''){
        this.loadingModals();
        this.$Message.error('请选择审核状态');
        return false;
      }
      let data = {'id':this.id,'status':this.radio,'check_remarks':this.remarks}
      this.$myhttp.post('admin/OrderDailyList/check',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadingModals();
          if(backdata.data.code == 201){
            this.$Message.error(backdata.data.message);
            return false;
          }
          this.id = '';
          this.radio = '';
          this.remarks= '';
          this.modal2 = false;
          this.$Message.success('操作成功');
          this.change(1);
      });
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.homeName=tree_str;
      this.change(1);
    }
  },
  watch: {

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
}
</script>

<style>
  .el-input.is-disabled .el-input__inner {
      background-color: #F5F7FA;
      border-color: #E4E7ED;
      color: #3e3f42 !important;
      cursor: not-allowed;
  }
</style>


<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.pay_margin{
  margin-left: 3px;
  width: 92px;
}

.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
}
.loading{
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/OrderDaily/Check.vue